<template>
    <component
        :is="href ? 'a' : 'button'"
        :href="href"
        :target="external ? '_blank' : undefined"
        :rel="external ? 'noopener' : undefined"
        class="ob-btn"
        :class="[`ob-btn--${variant}`, `ob-btn--${size}`, { 'ob-btn--full': fullWidth }]"
        :type="href ? undefined : type"
    >
        <slot />
    </component>
</template>

<script lang="ts" setup>
    withDefaults(defineProps<{
        variant?: 'primary' | 'inverse'
        size?: 'md' | 'lg'
        href?: string
        external?: boolean
        fullWidth?: boolean
        type?: 'button' | 'submit'
    }>(), {
        variant: 'primary',
        size: 'md',
        href: undefined,
        external: false,
        fullWidth: false,
        type: 'button',
    })
</script>

<style scoped>
    /* Port of the design-system Button (components/core/Button.jsx). */
    .ob-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border: 1px solid transparent;
        border-radius: 999px;
        font-family: 'Poppins', sans-serif;
        font-weight: 600;
        line-height: 1;
        letter-spacing: .01em;
        cursor: pointer;
        white-space: nowrap;
        text-decoration: none;
        transition: transform .12s cubic-bezier(.4, 0, .2, 1), filter .12s cubic-bezier(.4, 0, .2, 1);
    }
    .ob-btn:hover { filter: brightness(1.06); }
    .ob-btn:active { transform: scale(.97); }
    .ob-btn:focus-visible { outline: 3px solid var(--ob-blue-a45); outline-offset: 2px; }

    .ob-btn--md { gap: 8px; height: 44px; padding: 11px 22px; font-size: 15px; }
    .ob-btn--lg { gap: 10px; height: 54px; padding: 15px 30px; font-size: 17px; }
    .ob-btn--full { width: 100%; }

    .ob-btn--primary {
        background: var(--ob-blue);
        color: var(--ob-white);
        box-shadow: 0 10px 28px var(--ob-blue-a30);
    }
    .ob-btn--inverse {
        background: var(--ob-white);
        color: var(--ob-blue);
        box-shadow: 0 6px 18px rgba(0, 35, 70, .10);
    }
</style>
